import PropTypes from 'prop-types';
const React = require('react')
const capitalize = require('lodash/capitalize')
import {
  DropdownButton,
  Label,
  MenuItem
} from 'react-bootstrap'

export default class BoostSubjectDropdownSelector extends React.Component {
  constructor(props) {
    super(props)
  }

  static defaultProps = {
    dropdownBtnStyle : "link",
    showHeader: false
  }

  render() {
    var title = this.props.selectedItem ? this.props.selectedItem.name : `${capitalize(this.props.noun)}`
    if (title.length > 30)
      title = title.substring(0, 30) + '...'
    return (
        <DropdownButton
          id={this.props.noun + '-select'}
          title={title}
          bsStyle={this.props.dropdownBtnStyle}
          disabled={this.props.disabled == true}
        >
         {this.props.disabled &&
          <MenuItem
            eventKey={0}
          >
          {this.props.disabledText}
          </MenuItem>
          }
          {this.props.items && !this.props.items.length &&
          <MenuItem
            eventKey={0}
          >
          No {this.props.noun} available
          </MenuItem>
          }
          {this.props.showHeader && (
            <MenuItem header>Subjects</MenuItem>
          )}
          {this.props.items && this.props.selectedItem && (
          <MenuItem
            eventKey={0}
            onSelect={this.props.onClear}
          >
          Reset
          </MenuItem>
          )}
          {this.props.items && this.props.items.map((item, i) => (
          <MenuItem
            eventKey={item}
            key={item.id}
            onSelect={this.props.onSelect}
            active={this.props.selectedItem && this.props.selectedItem.id == item.id}
          >
            {item.name}
            {!item.boost_is_available &&
            <span>
              &nbsp; &nbsp; &nbsp;
              <Label>Coming in {item.boost_date_available}</Label>
            </span>
            }
          </MenuItem>
          ))}
        </DropdownButton>
    )
  }
}

BoostSubjectDropdownSelector.propTypes = {
  selectedItem: PropTypes.object,
  items: PropTypes.array,
  onSelect: PropTypes.func,
  onClear: PropTypes.func,
  noun: PropTypes.string.isRequired,
  dropdownBtnStyle: PropTypes.string
}
